import {createAsyncThunk} from "@reduxjs/toolkit";

export const updatePartnerDetails = createAsyncThunk('partnerDetails',
        async (values:any) => {
            console.log(values)
        }
    )